import { FunctionComponent } from "react";
import { Tooltip } from "@mui/material";
import { WarningAmber } from "@mui/icons-material";

type PropsType = {
  failed?: boolean;
};

const PriceCalculationFailedWarning: FunctionComponent<PropsType> = ({
  failed,
}) => {
  if (!failed) return null;

  return (
    <Tooltip title={<h5>Price calculation failed</h5>} placement="bottom">
      <WarningAmber
        color={"warning"}
        fontSize={"small"}
        sx={{ flexShrink: 0 }}
      />
    </Tooltip>
  );
};

export default PriceCalculationFailedWarning;
